const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function joinAbsoluteUrl(baseUrl: string, path: string): string {
  return new URL(path, `${trimTrailingSlash(baseUrl)}/`).toString();
}

export function buildAuthenticatedSessionPdfUrl(sessionId: string, apiBaseUrl: string): string {
  const normalizedBase = trimTrailingSlash(apiBaseUrl);
  return `${normalizedBase}/sessions/${sessionId}/pdf/download`;
}

export function buildPublicSessionPdfUrl(sessionId: string, publicBaseUrl: string): string {
  return joinAbsoluteUrl(publicBaseUrl, `/api/public/sessions/${sessionId}/pdf`);
}

export function buildSharePdfUrl(
  shareToken: string,
  apiBaseUrl: string,
  publicBaseUrl: string
): string {
  const relativePath = `${trimTrailingSlash(apiBaseUrl)}/public/share/${shareToken}/pdf`;
  if (ABSOLUTE_URL_PATTERN.test(relativePath)) {
    return relativePath;
  }
  return joinAbsoluteUrl(publicBaseUrl, relativePath);
}
